export let WFSVersions;(function(V){V["V100"]="1.0.0";V["V110"]="1.1.0";V["V200"]="2.0.0";V["V202"]="2.0.2"})(WFSVersions||(WFSVersions={}));